import { render, staticRenderFns } from "./vRegistro.vue?vue&type=template&id=bff54bd8&scoped=true&"
import script from "./vRegistro.vue?vue&type=script&lang=js&"
export * from "./vRegistro.vue?vue&type=script&lang=js&"
import style0 from "./vRegistro.vue?vue&type=style&index=0&id=bff54bd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff54bd8",
  null
  
)

export default component.exports